'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || 'Component';
}
//# sourceMappingURL=get-display-name.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-styleable/lib/utils/get-display-name.js
// module id = 746
// module chunks = 0